import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';

import { BehaviourListModel } from '../../../../../../../core/models/common.models';

@Component({
  selector: 'app-define-behavior-wizard-environments-step',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReactiveFormsModule, NzFormModule, NzCheckboxModule],
  templateUrl: './define-behavior-wizard-environments-step.component.html',
  styleUrl: './define-behavior-wizard-environments-step.component.scss',
})
export class DefineBehaviorWizardEnvironmentsStepComponent {
  @Input() form!: FormGroup;
  @Input() isRequired = false;
  @Input() behaviourEnvironmentList: BehaviourListModel[] = [];
  @Input() onCheckboxChange!: (
    controlName: string,
    checked: boolean,
    value: number
  ) => void;
  @Input() trackById!: (index: number, item: { id: number }) => number;
}
